import { LifeArea } from '@griply/types';

export const filterLifeAreasBySearchText = (
  lifeAreas: LifeArea[],
  searchText: string,
): LifeArea[] => {
  if (!searchText) {
    return [];
  }
  const trimmedSearchText = searchText.trim().toLowerCase();

  return lifeAreas
    .filter(({ name }) => name.toLowerCase().includes(trimmedSearchText))
    .sort((a, b) => a.name.localeCompare(b.name));
};
